/* eslint-disable react/no-unescaped-entities */
import React from 'react'

import { type ProviderContent } from '~/components/filter-banner/price-rise-banner'
import { PROVIDERS } from '~/utils/providers-listing'

export type ProvidersPriceRiseContent = {
  id: string | null
  priceIncrease?: number
  average?: boolean
  stillInContract?: JSX.Element
  priceDetails?: JSX.Element
  until?: string
  tableIntro?: JSX.Element
}

// Content below should reflect the "Broadband providers - mid-contract price rises" Notion document:
export const providersPriceRiseContent: ProvidersPriceRiseContent[] = [
  {
    id: '12827', // NOW
    average: true,
    priceIncrease: 6.7,
    stillInContract: (
      <p>You can leave your NOW Broadband contract penalty-free within 30 days of receiving a price rise notice.</p>
    ),
    priceDetails: (
      <>
        <p>NOW Broadband may increase your costs during your contract.</p>

        <p>
          They will usually let you leave your broadband contract penalty-free within 30 days of receiving a price rise
          notice.
        </p>
      </>
    )
  },
  {
    id: '12189', // Direct Save Telecom
    // priceIncrease: 0,
    average: true,
    stillInContract: (
      <p>
        You can leave your Direct Save Telecom broadband contract penalty-free within 30 days of receiving a price rise
        notice.
      </p>
    ),
    priceDetails: (
      <>
        <p>Direct Save Telecom may increase your costs during your contract.</p>

        <p>
          They will usually let you leave your broadband contract penalty-free within 30 days of receiving a price rise
          notice.
        </p>
      </>
    )
  },
  {
    id: '12175', // Sky
    priceIncrease: 6.7,
    average: true,
    stillInContract: (
      <>
        <p>You can leave your Sky broadband contract penalty-free within 30 days of receiving a price rise notice.</p>

        <p>
          If you have a Sky TV contract, you’ll need to pay a fee ending your contract early, usually based on the
          remaining months.
        </p>
      </>
    ),
    priceDetails: (
      <>
        <p>Sky may increase your costs during your contract.</p>

        <p>
          They will usually let you leave your broadband contract penalty-free within 30 days of receiving a price rise
          notice.
        </p>

        <p>If you have a TV contract, you may have to pay a fee for leaving early, based on remaining months.</p>
      </>
    )
  },
  {
    id: '12786', // Gigaclear
    // priceIncrease: ,
    average: true,
    stillInContract: (
      <p>
        You can leave your Gigaclear Broadband contract penalty-free within 30 days of receiving a price rise notice.
      </p>
    ),
    priceDetails: (
      <>
        <p>Gigaclear may increase your costs during your contract.</p>

        <p>
          They will usually let you leave your broadband contract penalty-free within 30 days of receiving a price rise
          notice.
        </p>
      </>
    )
  },
  {
    id: '12191', // Three
    priceIncrease: 7.9,
    stillInContract: (
      <p>Three charge fees for ending your contract early, usually based on remaining months with 30 days notice.</p>
    ),
    priceDetails: (
      <>
        <p>
          Your monthly cost will rise every April during your contract by the Consumer Price Index (CPI) rate of
          inflation, plus an extra 3.9%.
        </p>

        <p>
          In 2024, the total increase is 7.9%. So, if you currently pay £30.00, from 1 April you will pay an extra £2.37
          a month.
        </p>
      </>
    )
  },
  {
    id: '12837', // KCOM
    priceIncrease: 7.9,
    stillInContract: (
      <p>KCOM charge fees for ending your contract early, usually based on remaining months with 30 days notice.</p>
    ),
    priceDetails: (
      <>
        <p>
          Your monthly cost will rise every April during your contract by the Consumer Price Index (CPI) rate of
          inflation, plus an extra 3.9%.
        </p>

        <p>
          In 2024, the total increase is 7.9%. So, if you currently pay £30.00, from 1 April you will pay an extra £2.37
          a month.
        </p>
      </>
    )
  },
  {
    id: '12165', // TalkTalk
    priceIncrease: 7.7,
    until: '2025',
    stillInContract: (
      <p>TalkTalk charge fees for ending your contract early, usually based on remaining months with 30 days notice.</p>
    ),
    priceDetails: (
      <>
        <p>
          TalkTalk are freezing their prices for new customers until 2025. That means if you switch today, you won’t get
          a price rise this year.
        </p>

        <p>
          From 2025, your monthly cost will rise every April during your contract by the Consumer Price Index (CPI) rate
          of inflation, plus an extra 3.7%.
        </p>
      </>
    )
  },
  {
    id: '12834', // Zen

    stillInContract: (
      <p>Zen charge fees for ending your contract early, usually based on remaining months with 30 days notice.</p>
    ),
    priceDetails: (
      <>
        <p>Good news! Zen won’t increase your monthly cost during your contract.</p>
      </>
    )
  },
  {
    id: '12851', // Gigabit
    stillInContract: (
      <p>Gigabit does not charge fees for ending your contract early, but usually need 30 days notice.</p>
    ),
    priceDetails: (
      <>
        <p>Good news! Gigabit won’t increase your monthly cost during your contract.</p>
      </>
    ),
    priceIncrease: 0
  },
  {
    id: '12850', // Yayzi
    stillInContract: (
      <p>Yayzi charge fees for ending your contract early, usually based on remaining months with 30 days notice.</p>
    ),
    priceDetails: (
      <>
        <p>Good news! Yayzi won’t increase your monthly cost during your contract.</p>
      </>
    ),
    priceIncrease: 0
  },
  {
    id: '12846', // Trooli
    stillInContract: (
      <p>Trooli charges fees for ending your contract early, usually based on remaining months with 30 days notice.</p>
    ),
    priceDetails: (
      <>
        <p>Good news! Trooli won’t increase your monthly cost during your contract.</p>
      </>
    ),
    priceIncrease: 0
  },
  {
    id: '12842', // Squirrel
    stillInContract: (
      <p>Squirrel charge fees for ending your contract early, usually based on remaining months with 30 days notice.</p>
    ),
    priceDetails: (
      <>
        <p>Good news! Squirrel won’t increase your monthly cost during your contract.</p>
      </>
    ),
    priceIncrease: 0
  },
  {
    id: '12840', // Open fibre
    stillInContract: (
      <p>Open Fibre does not charge fees for ending your contract early, but usually need 30 days notice.</p>
    ),
    priceDetails: (
      <>
        <p>Good news! Open Fibre won’t increase your monthly cost during your contract.</p>
      </>
    ),
    priceIncrease: 0
  },
  {
    id: '12845', // Octaplus
    stillInContract: (
      <p>Octaplus charge fees for ending your contract early, usually based on remaining months with 30 days notice.</p>
    ),
    priceDetails: (
      <>
        <p>Good news! Octaplus won’t increase your monthly cost during your contract.</p>
      </>
    ),
    priceIncrease: 0
  },
  {
    id: '12843', // Link broadband
    stillInContract: (
      <p>Link charge fees for ending your contract early, usually based on remaining months with 30 days notice.</p>
    ),
    priceDetails: (
      <>
        <p>Good news! Link Broadband won’t increase your monthly cost during your contract.</p>
      </>
    ),
    priceIncrease: 0
  },
  {
    id: '12844', // Infinics
    stillInContract: (
      <p>Infinics charge fees for ending your contract early, usually based on remaining months with 30 days notice.</p>
    ),
    priceDetails: (
      <>
        <p>Good news! Infinics won’t increase your monthly cost during your contract.</p>
      </>
    ),
    priceIncrease: 0
  },
  {
    id: '12774', // Hyperoptic
    stillInContract: (
      <p>
        Hyperoptic charge fees for ending your contract early, usually based on remaining months with 30 days notice.
      </p>
    ),
    priceDetails: (
      <>
        <p>Good news! Hyperoptic won’t increase your monthly cost during your contract.</p>
      </>
    ),
    priceIncrease: 0
  },
  {
    id: '12839', // Hull fibre
    stillInContract: (
      <p>
        Hull Fibre charge fees for ending your contract early, usually based on remaining months with 30 days notice.
      </p>
    ),
    priceDetails: (
      <>
        <p>Good news! Hull Fibre won’t increase your monthly cost during your contract.</p>
      </>
    ),
    priceIncrease: 0
  },
  // {
  //   id: '', // Fibre Zone
  //   stillInContract: <p>Fibre Zone charge fees for ending your contract early, usually based on remaining months with 30 days notice.</p>,

  //   priceDetails: (
  //     <>
  //       <p>Good news! Fibre Zone won’t increase your monthly cost during your contract.</p>
  //     </>
  //   ),
  //   priceIncrease: 0
  // },
  {
    id: '12836', // Cuckoo
    stillInContract: (
      <p>Cuckoo charge fees for ending your contract early, usually based on remaining months with 30 days notice.</p>
    ),
    priceDetails: (
      <>
        <p>Good news! Cuckoo won’t increase your monthly cost during your contract.</p>
      </>
    ),
    priceIncrease: 0
  },
  {
    id: '12833', // Shell energy broadband
    priceIncrease: 6.0,
    stillInContract: (
      <p>
        Shell Energy Broadband charge fees for ending your contract early, usually based on remaining months with 30
        days notice.
      </p>
    ),
    priceDetails: (
      <>
        <p>
          Shell Energy Broadband are freezing their prices for new customers until 2025. That means if you switch today,
          you won’t get a price rise this year.
        </p>

        <p>
          From 2025, your monthly cost will rise every April during your contract by the Consumer Price Index (CPI) rate
          of inflation, plus an extra up to 3%.
        </p>
      </>
    ),
    until: '2025'
  },
  {
    id: '12828', // Onestream
    priceIncrease: 8.8,
    stillInContract: (
      <p>
        Onestream charge fees for ending your contract early, usually based on remaining months with 30 days notice.
      </p>
    ),
    priceDetails: (
      <>
        <p>
          Onestream are freezing their prices for new customers until 2025. That means if you switch today, you won’t
          get a price rise this year.
        </p>

        <p>
          From 2025, your monthly cost will rise every April during your contract by the Retail Price Index (RPI) rate
          of inflation, plus an extra 3.9%.
        </p>
      </>
    ),
    until: '2025'
  },
  {
    id: '12835', // Community Fibre
    priceIncrease: 6.9,
    stillInContract: (
      <p>
        Community Fibre charge fees for ending your contract early, usually based on remaining months with 30 days
        notice.
      </p>
    ),
    priceDetails: (
      <>
        <p>
          Community Fibre are freezing their prices for new customers until 2025. That means if you switch today, you
          won’t get a price rise this year.
        </p>

        <p>
          From 2025, your monthly cost will rise every April during your contract by the Consumer Price Index (CPI) rate
          of inflation, plus an extra 2.9%.
        </p>
      </>
    ),
    until: '2025'
  },
  {
    id: '12193', // Vodafone
    priceIncrease: 7.9,
    stillInContract: (
      <p>Vodafone charge fees for ending your contract early, usually based on remaining months with 30 days notice.</p>
    ),
    priceDetails: (
      <>
        <p>
          Vodafone are freezing their prices for new customers until 2025. That means if you switch today, you won’t get
          a price rise this year.
        </p>

        <p>
          From 2025, your monthly cost will rise every April during your contract by the Consumer Price Index (CPI) rate
          of inflation, plus an extra 3.9%.
        </p>
      </>
    ),
    until: '2025'
  },
  {
    id: '12185', // Plusnet
    priceIncrease: 7.9,
    stillInContract: (
      <p>Plusnet charge fees for ending your contract early, usually based on remaining months with 30 days notice.</p>
    ),
    priceDetails: (
      <>
        <p>
          Plusnet are freezing their prices for new customers until 2025. That means if you switch today, you won’t get
          a price rise this year.
        </p>

        <p>
          From 2025, your monthly cost will rise every April during your contract by the Consumer Price Index (CPI) rate
          of inflation, plus an extra 3.9%.
        </p>
      </>
    ),
    until: '2025'
  },
  {
    id: '12179', // Virgin Media,
    priceIncrease: 8.8,
    until: '2025',
    stillInContract: (
      <p>
        Virgin Media charge fees for ending your contract early, usually based on remaining months with 30 days notice.
      </p>
    ),
    priceDetails: (
      <>
        <p>
          Virgin Media are freezing their prices for new customers until 2025. That means if you switch today, you won’t
          get a price rise this year.
        </p>

        <p>
          From 2025, your monthly cost will rise every April during your contract by the Retail Price Index (RPI) rate
          of inflation, plus an extra 3.9%.
        </p>
      </>
    )
  },
  {
    id: '12153', // BT
    priceIncrease: 7.9,
    stillInContract: (
      <p>BT charge fees for ending your contract early, usually based on remaining months with 30 days notice.</p>
    ),
    until: '2025',
    priceDetails: (
      <>
        <p>
          BT are freezing their prices for new customers until 2025. That means if you switch today, you won’t get a
          price rise this year.
        </p>
        <p>
          From 2025, your monthly cost will rise every April during your contract by the Consumer Price Index (CPI) rate
          of inflation, plus an extra 3.9%.
        </p>
      </>
    )
  },
  {
    id: '12852', // YouFibre
    stillInContract: (
      <p>YouFibre charge fees for ending your contract early, usually based on remaining months with 30 days notice.</p>
    ),
    priceDetails: (
      <>
        <p>Good news! YouFibre won’t increase your monthly cost during your contract.</p>
      </>
    ),
    priceIncrease: 0
  },
  {
    id: null, // Provider NULL
    priceIncrease: 8.8,
    tableIntro: (
      <p>
        Many broadband providers increase their prices each year in April. Based on 2024 figures, this could see your
        bill rise by&nbsp;<b>up to 8.8%</b>.
      </p>
    ),
    stillInContract: (
      <p>
        Providers may charge fees for ending your contract early, usually based on remaining months with 30 days notice.
      </p>
    ),
    priceDetails: (
      <>
        <p>
          Some providers are freezing their prices until 2025, while some others don't have any mid-contract price rises
          at all.
        </p>
      </>
    )
  }
]

export const getProviderPriceRiseContent = (providerId: string | undefined) => {
  const combineProviderContent = (
    providerContent: ProvidersPriceRiseContent,
    genericProviderContent?: ProviderContent
  ) => {
    const combinedContent = {
      ...providerContent,
      ...genericProviderContent
    } as ProviderContent & ProvidersPriceRiseContent

    return combinedContent
  }

  const genericProviderContent = PROVIDERS.find((provider) => provider.id === providerId)

  const providerContent = providersPriceRiseContent.find((provider) => provider.id === providerId ?? null)

  if (providerContent && genericProviderContent) return combineProviderContent(providerContent, genericProviderContent)

  const nullProviderContent = providersPriceRiseContent.find(
    (provider) => provider.id === null
  ) as ProvidersPriceRiseContent

  return combineProviderContent(nullProviderContent)
}
